import { makeStyles } from '@mui/styles';

const useStyles = makeStyles({
  '@keyframes slideIn': {
    '0%': {
      transform: 'translateX(-100%)',
    },
    '100%': {
      transform: 'translateX(0)',
    },
  },
  projectsContainer: {
    animation: '$slideIn 1s ease-out',
    textAlign: 'center',
    padding: '1rem',
    color: '#fff',
    '@media (max-width: 1200px)': {
      padding: '0.5rem',
    },
    '@media (max-width: 768px)': {
      padding: '0.25rem', // Reduce el padding en móviles
    },
  },
  projectsDescription: {
    marginBottom: '1.5rem',
    '@media (max-width: 768px)': {
      fontSize: '1.4rem', // Reduce el tamaño del texto en móviles
    },
  },
  mainText: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    textAlign: 'justify',
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Apila los elementos verticalmente en móviles
      textAlign: 'center', // Centra el texto en móviles
    },
  },
  textWithImage: {
    display: 'flex',
    alignItems: 'center',
    gap: '2rem',
    width: '100%',
    '@media (max-width: 768px)': {
      flexDirection: 'column', // Apila los elementos verticalmente en móviles
      gap: '1rem', // Reduce el espacio entre elementos en móviles
    },
  },
  projectsImage: {
    maxWidth: '40%',
    height: 'auto',
    '@media (max-width: 768px)': {
      maxWidth: '80%', // Aumenta el tamaño de la imagen en móviles
    },
  },
  secondText: {
    width: '60%',
    margin: '0 auto',
    textAlign: 'center',
    '@media (max-width: 768px)': {
      width: '90%', // Aumenta el ancho del texto en móviles
    },
  },
  projectsSubtitle: {
    marginTop: '5rem',
    background: 'linear-gradient(0deg, rgba(0,168,232,1) 0%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    '@media (max-width: 1200px)': {
      marginTop: '3rem',
    },
    '@media (max-width: 768px)': {
      marginTop: '2rem', // Reduce el margen superior en móviles
      fontSize: '2.5rem', // Reduce el tamaño del subtítulo en móviles
    },
  },
  digitlaTransformationTitle: {
    marginTop: '5rem',
    background: 'linear-gradient(0deg, rgba(0,168,232,1) 0%, rgba(253,253,253,1) 73%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    '@media (max-width: 1200px)': {
      marginTop: '3rem',
    },
    '@media (max-width: 768px)': {
      marginTop: '2rem', // Reduce el margen superior en móviles
      fontSize: '2.5rem', // Reduce el tamaño del título en móviles
    },
  },
  digitlaTransformationDescription: {
    marginBottom: '3.5rem',
    '@media (max-width: 1200px)': {
      marginBottom: '2rem',
    },
    '@media (max-width: 768px)': {
      fontSize: '1.4rem', // Reduce el tamaño del texto en móviles
    },
  },
  imgCentered: {
    display: 'flex',
    justifyContent: 'center',
    gap: '3rem',
    marginTop: '2rem',
    flexWrap: 'wrap',
    width: 'auto',
    height: 'auto',
    '@media (max-width: 1200px)': {
      gap: '1.5rem',
      marginTop: '1.5rem',
    },
    '@media (max-width: 768px)': {
      gap: '1rem', // Reduce el espacio entre imágenes en móviles
      marginTop: '1rem', // Reduce el margen superior en móviles
    },
  },
});

export default useStyles;
